import { useState, useMemo } from 'react';
import { Zap } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import ProductCard from '@/components/ProductCard';
import { useDealsProducts } from '@/hooks/useProducts';
import { Skeleton } from '@/components/ui/skeleton';

const DealsPage = () => {
  const [sort, setSort] = useState('discount');
  const { data: rawDeals = [], isLoading } = useDealsProducts();

  const deals = useMemo(() => {
    const sorted = [...rawDeals];
    switch (sort) {
      case 'discount': return sorted.sort((a, b) => b.discount - a.discount);
      case 'price-low': return sorted.sort((a, b) => a.price - b.price);
      case 'savings': return sorted.sort((a, b) => (b.original_price - b.price) - (a.original_price - a.price));
      default: return sorted;
    }
  }, [rawDeals, sort]);

  return (
    <div>
      <div className="bg-gradient-to-r from-destructive/90 to-warning text-primary-foreground py-12 text-center">
        <Zap className="h-10 w-10 mx-auto mb-3" />
        <h1 className="font-heading text-3xl md:text-4xl font-extrabold mb-2">Hot Deals & Offers</h1>
        <p className="opacity-80">Grab the best discounts on genuine electronics</p>
      </div>

      <div className="container section-padding">
        <div className="flex items-center justify-between mb-6">
          <p className="text-sm text-muted-foreground">{deals.length} deals available</p>
          <Select value={sort} onValueChange={setSort}>
            <SelectTrigger className="w-44"><SelectValue placeholder="Sort by" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="discount">Highest Discount %</SelectItem>
              <SelectItem value="price-low">Lowest Price</SelectItem>
              <SelectItem value="savings">Most Savings (₹)</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {isLoading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-72 rounded-xl" />)}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {deals.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default DealsPage;
